import type { ReactNode } from 'react'
import { cn } from '../../utils/cn'

/** Keyboard key hint, e.g. <Kbd>⌘K</Kbd> */
export function Kbd({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <kbd className={cn('inline-flex items-center justify-center min-w-[1.5rem] h-5 px-1 rounded border border-line-strong bg-surface-sunken text-fg-muted text-xs font-mono leading-none shadow-[inset_0_-1px_0_rgb(0_0_0/0.15)]', className)}>
      {children}
    </kbd>
  )
}

export const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform)
export const MOD_KEY = isMac ? '⌘' : 'Ctrl'

export default Kbd
